import script from "./ProgramOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgramOverview.vue?vue&type=script&setup=true&lang=js"

import "./ProgramOverview.vue?vue&type=style&index=0&id=6ae59632&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ae59632"]])

export default __exports__